import { ExtraDataService } from "../../services/extraDataService";
import { ReferenceType } from "../../objects/extraData/extraDataSearchRequest";
import { ExtraData } from "../../objects/extraData/extraData";
/**
 * Created by vadim.m on 10/26/2017.
 */
export class BaseExtraData {
    constructor(public extraDataService: ExtraDataService) {
    }

    public async getExtraData(customerId: string, referenceType: ReferenceType): Promise<ExtraData> {
        let extraData = await this.extraDataService.getByRefIdandRefType(customerId, referenceType);
        if (!extraData || !extraData.Data)
            return new ExtraData();

        return extraData.Data.find(x => x.Name == 'marketing text');
    }
}



// WEBPACK FOOTER //
// ./app/components/extraData/baseExtraData.ts